import React from 'react';
import './DepartmentSelector.css';

const DepartmentSelector = ({data, selectedTab, handleToggleTab}) => {
  return (
    <div className='department-selector'>
      <ul className='department-selector__tab-list'>
        {Object.entries(data).map(([uuid, tab]) => (
          <li
            key={uuid}
            onClick={() => handleToggleTab(uuid)}
            className={`department-selector__tab-item ${
              selectedTab === uuid ? 'selected' : ''
            }`}
          >
            {tab.name}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DepartmentSelector;
